import {Component, OnInit, OnDestroy, ElementRef, HostListener, HostBinding} from '@angular/core';

// Services
import {CatalogService} from '../../services/catalog-service';
import {AppService} from '../../../../shared/services/app-service';
import {CartService} from '../../services/cart-service';
import {SceneService} from '../../services/scene-service';
import {AnimateService} from '../../../../shared/services/animate-service';

// Classes
import {Product} from '../../classes/product';

// Data
import {productOptions} from '../../data/product-options';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:SceneCmp'));

// let Ps = require('perfect-scrollbar');
declare var graphicsLayersHorizontalScroll: any;

/**
 * Used to render the virtual spa layers
 */
@Component({
    selector: 'scene-cmp',
    template: require('./scene.cmp.html'),
    styles: [String(require('./scene.cmp.scss'))],
    host: { id: 'graphics', class:'scene' }
})
export class SceneCmp {

    // @HostBinding('class.preview-closed') previewIsClosed: boolean = true;

    @HostListener('window:resize', ['$event']) onResize(event) {
        var self = this;

        // Called to ensure proper background coverage before sidebar opening animation begins.
        self.resizeLayersContainer()

        // Timeout calls graphics layer resize after sidebar opening animation ends,
        // thus resulting the corect width value.
        setTimeout(() => self.resizeLayersContainer(), 300);
        this.scrollToFocusPoint();
        // Ps.update(this.graphicsLayersElement); // Update navigation custom scroll
    }


    private _cartProducts = {};
    private _sceneProducts = {};
    private _timeouts = {};
    // temporaryProduct = null;
    // FinishCode = null;
    // selectedControl = null;
    // spaFrame = null;
    // spaFrameDefaultOption = null;
    private _imgPaths = null;
    // uiState = null;
    graphicsLayersElement = null;
    layersContainer = null;
    cancelHorizMouseScroll = null;
    overflowX: boolean = false;
    overflowY: boolean = false;
    scrollbarXisVisible: boolean = false;
    scrollbarYisVisible: boolean = false;
    scrollFocusPoint = 0.5;
    // subscriptions: any = {};
    // listeners = {
    //     graphicsLayersScroll: null
    // };
    timeouts = {
        scrollToFocusPoint: null
    };

    
    constructor (
        private _catalogService: CatalogService,
        private _cartService: CartService,
        private _appService: AppService,
        private _sceneService: SceneService,
        private _elementRef: ElementRef,
        private _animateService: AnimateService
    ) {
        // 'Construct scene component' );

        this._imgPaths = this._catalogService.imgPaths;
        this._cartProducts = this._cartService.getCartProducts();
        this._sceneProducts = this._sceneService.getSceneProducts();
        this.graphicsLayersElement = _elementRef.nativeElement;

    }

    
    ngOnInit() {
        // 'Initialise scene component' );
        var self = this,
            graphicsLayers = this._elementRef.nativeElement;

        this.layersContainer = document.getElementById('layers-container');
        this.resizeLayersContainer();
        this.scrollToFocusPoint();

        // Setup navigation custom scroll
        // Ps.initialize(this.graphicsLayersElement, {
        //     minScrollbarLength: 30,
        //     stopPropagationOnClick: false
        // });

    }

    // TODO: Trigger warning that finish was not received from parent package
    
    private _getSpaFrameImg () {
        if (this._appService.state.selectedControl === null) { return null; }

        debugOff( 'Get spa frame scene image path' );

        let selectedColor, selectedFinish, imageName;

        // Detect whether product has a finish option either a color options
        if (this._appService.state.selectedControl.vSpa.spaFrameSourceOption === 'color') {
            selectedColor = this._appService.state.selectedControl.options.selected.color;
            if (productOptions.color[selectedColor]) {
                imageName = productOptions.color[selectedColor].spaFrame;
            }
        } else if (this._appService.state.selectedControl.vSpa.spaFrameSourceOption === 'finish') {

            selectedFinish = this._appService.state.selectedControl.options.selected.finish;
            debugOff( 'Selected finish:', selectedFinish );

            if (productOptions.finish[selectedFinish]) {
                imageName = productOptions.finish[selectedFinish].spaFrame;
            }
        }
        debugOff( "Spa frame image:", imageName );

        // Return spa frame image name
        let spaFrameImgPath = 'url(' + this._imgPaths.scene + 'SpaFrame-' + imageName + ')';
        debugOff( 'Path:', spaFrameImgPath );
        return spaFrameImgPath;
    }


    private resizeLayersContainer() {
        var bgrH = 455,
            bgrW = 700,
            tolerance = 0.05,
            graphicsLayers = this.graphicsLayersElement,
            containRatioHeight = Math.ceil(this.graphicsLayersElement.offsetWidth * bgrH / bgrW),
            coverRatioWidth = Math.ceil(window.innerHeight * bgrW / bgrH);

        // Layers container size emulates background-size:cover;
        if (containRatioHeight < window.innerHeight) {
            this.layersContainer.style.width = coverRatioWidth + 'px';
            if (window.innerWidth <= 680) {
                this.layersContainer.style.height = window.innerHeight - 60 + 'px';
            } else {
                this.layersContainer.style.height = window.innerHeight + 'px';
            }
            if (this.overflowX === false) {
                this.overflowX = true;
                this.overflowY = false;

                        // <!> CAUTION <!>
                        // graphicsLayersHorizontalScroll is a global variable used to bypass the perfect scroll script
                        // It alows the capture of mousewheel event
                        // Do not update perfect-scroll.js before fixing this hardcode issue

                // Scroll graphics layers horitontally
                //this.cancelHorizMouseScroll = UI.horizontalMouseScroll(graphicsLayers);
                // graphicsLayersHorizontalScroll = UI.horizontalMouseScroll;
            }
        } else {
            this.layersContainer.style.width = graphicsLayers.offsetWidth + 'px';
            this.layersContainer.style.height = containRatioHeight + 'px';
            if (this.overflowY === false) {
                this.overflowX = false;
                this.overflowY = true;

                // Cancel horizontal scroll. Return to vertical scroll
                //this.cancelHorizMouseScroll !== null && this.cancelHorizMouseScroll();
                // graphicsLayersHorizontalScroll = null;
            }
        }

        // Remove scrollbar if tolerance threshold is not exceeded;
        if (containRatioHeight < window.innerHeight - window.innerHeight * tolerance) {
            if (this.scrollbarXisVisible === false) { // scrollbarYisVisible
                this.scrollbarXisVisible = true;
                this.scrollbarYisVisible = false;
                graphicsLayers.classList.remove('overflow-y');
                graphicsLayers.classList.add('overflow-x');
            }
        } else if (containRatioHeight > window.innerHeight + window.innerHeight * tolerance) {
            if (this.scrollbarYisVisible === false) {
                this.scrollbarXisVisible = false;
                this.scrollbarYisVisible = true;
                graphicsLayers.classList.remove('overflow-x');
                graphicsLayers.classList.add('overflow-y');
            }
        } else {
            if (this.scrollbarXisVisible !== false || this.scrollbarYisVisible !== false) {
                this.scrollbarXisVisible = false;
                this.scrollbarYisVisible = false;
                graphicsLayers.classList.remove('overflow-x', 'overflow-y');
            }
        }
    }

    centerScrollOnTooltips(tooltips) {
        var prevMin, prevMax, min, max, position, dimension,
            total = 100;

        // Select current overflow axis
        if (this.overflowX === true) {
            position = 'DistLeft';
            dimension = 'Width';
        } else {
            position = 'DistTop';
            dimension = 'Height';
        }

        // Init or return if no tooltips
        if (typeof tooltips !== 'undefined' &&
            tooltips !== null &&
            tooltips.length !== 0
        ) {
            min = tooltips[0][position];
            max = tooltips[0][position] + tooltips[0][dimension];
            prevMin = min;
            prevMax = max;
        } else { return; }

        // Detect min and max range
        tooltips.forEach(tooltip => {
            tooltip[position] < prevMin && (min = tooltip[position]);
            tooltip[position] + tooltip[dimension] > prevMax && (max = tooltip[position] + tooltip[dimension]);
            prevMin = min;
            prevMax = max;
        });

        this.scrollFocusPoint = ((max - min) / 2 + min) / 100;
        this.scrollToFocusPoint();
    }

    scrollToFocusPoint() {
        if (this.scrollbarXisVisible === false && this.scrollbarYisVisible === false) { return; }

        var self = this,
            scrollPosition,
            scrollFinalPosition;

        // Compute scroll position for the current axis of overflow
        if (this.overflowX === true) {
            scrollPosition = this.graphicsLayersElement.scrollLeft;
            scrollFinalPosition = calcFocusPoint(
                this.layersContainer.offsetWidth,
                this.graphicsLayersElement.offsetWidth
            );
        } else {
            scrollPosition = this.graphicsLayersElement.scrollTop;
            scrollFinalPosition = calcFocusPoint(
                this.layersContainer.offsetHeight,
                window.innerHeight
            );
        }

        function calcFocusPoint(total, dimension) {
            return Math.ceil(total * self.scrollFocusPoint - dimension / 2);
        }

        // Delay the animation in order to reduce the number of UI.animate() calls
        this.timeouts.scrollToFocusPoint !== null && clearTimeout(this.timeouts.scrollToFocusPoint);
        this.timeouts.scrollToFocusPoint = setTimeout(animateScroll, 100);

        function animateScroll() {
            self._animateService.start(scrollPosition, scrollFinalPosition, 300, 'easeInOutQuad', function (curr, count, max) {
                if (self.overflowX === true) {
                    self.graphicsLayersElement.scrollLeft = curr;
                } else {
                    self.graphicsLayersElement.scrollTop = curr;
                }
            }, this._timeouts, 'scrollToFocusPoint');
        }
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/components/scene/scene.cmp.ts